var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { open: true, "has-header": "", "has-footer": "" },
    on: { close: () => _vm.$emit("onCancel") },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h2", { staticClass: "emd-text _size_section" }, [
              _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.isLastTerminal
              ? _c("emd-alert", {
                  attrs: {
                    variant: "warning",
                    title: _vm.$t("alertTitle"),
                    noClose: "",
                  },
                })
              : _vm._e(),
            _c(
              "p",
              {
                staticClass: "eu-mt_2 eu-mb_2 _paragraph",
                attrs: { "data-testid": "isLastTerminalAlert" },
              },
              [_vm._v(" " + _vm._s(_vm.$t("content")) + " ")]
            ),
            _vm.isLastTerminal
              ? _c("jade-checkbox", {
                  attrs: {
                    id: "last-terminal-checkbox",
                    value: _vm.isCheck,
                    label: _vm.$t("confirmCheckbox"),
                  },
                  on: {
                    "update:value": function ($event) {
                      _vm.isCheck = $event
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "eu-flex eu-justify_end eu-width_100" },
              [
                _c("emd-button", {
                  attrs: {
                    "data-testid": "button-success-reset-secret-key",
                    type: "text",
                    color: "success",
                    text: _vm.$t("cancelButton"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onCancel")
                    },
                  },
                }),
                _c("emd-button", {
                  attrs: {
                    "data-testid": "button-success-reset-secret-key",
                    color: "success",
                    text: _vm.$t("submitButton"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onSubmit")
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }